module.exports = __webpack_public_path__ + "img/deliveries.b5f27709.svg";